import { render, staticRenderFns } from "./TextDiffViewer.vue?vue&type=template&id=569eb260"
import script from "./TextDiffViewer.js?vue&type=script&lang=js&external"
export * from "./TextDiffViewer.js?vue&type=script&lang=js&external"
import style0 from "./TextDiffViewer.vue?vue&type=style&index=0&id=569eb260&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports